import 'jquery';
import 'select2';

const $ = jQuery.noConflict();

const woocommerceOrderSelect = function() {
	$('.woocommerce-ordering select option').first().html('Sort by');
	$('.woocommerce-ordering select').select2({
		minimumResultsForSearch: Infinity,
		width: '100%',
	});
}

const woocommerceVariationSelect = function() {
	$('.woocommerce .summary.entry-summary select').select2({
		minimumResultsForSearch: Infinity,
		width: '100%',
	});
}

const woocommerceSelect = function() {
	woocommerceOrderSelect();
	woocommerceVariationSelect();
}

export default woocommerceSelect;